import PriceOfferCalculator from "@modules/stock_locator/views/PriceOffer/PriceOffer.calculator.js";
import PriceOfferProperties from "@modules/stock_locator/views/PriceOffer/PriceOffer.properties.js";

class PriceOffer {
    constructor() {
        this.component = '[component].PriceOffer';
        this.el = $(this.component);

        this.creating = false;
        this.formSaved = false;
        this.formChanged = false;
        this.valuesInserted = false;

        if (!this.el.length) {
            return;
        }

        this.form = this.el.find("form");
        this.formInputs = this.form.find("input, textarea");
        this.submitButton = this.el.find(".submit");
        this.template = this.el.find('.view .template');
        this.personTypeSelect = this.form.find("#person_type");
        this.orientationButton = this.el.find(".change-orientation");

        this.start();
        this.bind();
    }

    start() {
        this.observeContentChange();

        this.setPlaceholderTitles();
        this.updateInputValuesToPlaceholders();
        this.highlightEmptyInputs();

        new PriceOfferProperties(this.component, true);
        // new PriceOfferEquipments(this.component, true);
        new PriceOfferCalculator(this.component, true);

        this.accessSubmitButton();
    }

    bind() {
        this.formInputs.on("focusin focusout mouseenter mouseleave", (event) => {
            this.resetPlaceholders();

            const input = $(event.currentTarget);
            const placeholder = this.el.find(`[name="${input.attr("id")}"]`);

            if (!placeholder.length) {
                return;
            }

            const isActive = event.type === "mouseenter" || event.type === "focusin";
            placeholder.toggleClass("highlight", isActive);
        });

        this.formInputs.on("change", (event) => {
            const input = $(event.currentTarget);
            const value = input.val();
            const placeholder = this.template.find(`[name="${input.attr("id")}"]`);

            placeholder.text(value);
            input.toggleClass("invalid", value.length === 0);

            this.formChanged = true;
            this.accessSubmitButton();
        });


        this.el.find("select.offer-person_type").on("change", (event) => {
            const input = $(event.currentTarget);

            if (input.is('[name="person_type"]') === true) {
                let value = input.val();

                let physicalPerson = this.el.find(".physicalPerson");
                let legalPerson = this.el.find(".legalPerson");

                physicalPerson.hide(0);
                legalPerson.hide(0);

                if (value === "physical-person") {
                    physicalPerson.show(0);
                }

                if (value === "legal-person") {
                    legalPerson.show(0);

                    legalPerson.find("input").each(function () {
                        let input = $(this);

                        input.val("").trigger("change");
                    });
                }
            }
        });

        this.submitButton.on("click", (event) => {

            if (!this.isFormFilled() || this.creating) {
                return;
            }

            const button = $(event.currentTarget);

            this.creating = true;
            const loading = button.find(".loading");
            const hash = this.getHash() || this.generateRandomString(30);

            loading.addClass("visible");

            let formData = new FormData();
            formData.append('action', 'print');
            formData.append('hash', hash);

            this.form.find('input, select, textarea').each(function () {
                let input = $(this);
                let name = input.attr('id');
                let value = input.val();

                // Append only if the input has a name attribute
                if (name) {
                    formData.append(name, value);
                }
            });

            this.updateHash(hash);

            $.ajax({
                data: formData,
                processData: false,
                contentType: false,
                //dataType: 'blob',    // Expect binary data (blob) from the server
                url: WEB_ROOT + '/modules/stock_locator/views/PriceOffer/PriceOffer.async.php?hash=' + hash,
                type: 'POST',
                xhrFields: {
                    responseType: 'blob'
                },
                success: (response, textStatus, jqXHR) => {
                    loading.removeClass("visible");

                    // console.log(response); // Log the response
                    if (response instanceof Blob) {
                        //const url = URL.createObjectURL(response);
                        //window.open(url, '_blank'); // Open PDF in a new tab
                        //URL.revokeObjectURL(url);  // Cleanup URL after usage

                        const blob = new Blob([response], {type: 'application/pdf'});

                        // Create an object URL for the blob
                        const objectURL = window.URL.createObjectURL(blob);

                        // Open the PDF in a new tab/window
                        window.open(objectURL, '_blank');
                    } else {
                        console.error('Response is not a Blob');
                    }

                    this.creating = false;
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('AJAX Error:', textStatus, errorThrown);
                    console.log('Response Text:', jqXHR.responseText); // Log the response text for debugging

                    this.creating = false;
                }
            });
        });

        $(".placeholder").on("keyup", (el) => this.bindPlaceholder(el));
        this.orientationButton.on("click", (el) => this.onOrientationChange(el));

        $(document).on("focusin", ".placeholder", (el) => {
            this.focusAndSelectAll($(el.currentTarget)[0]);
        });

        window.addEventListener('beforeunload', () => {
            // Check if any of the input fields are filled
            if (this.formChanged === true && this.formSaved === false) {

                // Cancel the event and show alert that
                // the unsaved changes would be lost
                e.preventDefault();
                e.returnValue = '';
            }
        });

        $(".PriceOffer").on("click", (el) => {

            if (el.altKey !== true && el.altKey !== true) {
                return;
            }

            this.debugFill(this.form);
        });
    }

    bindPlaceholder(el) {
        const placeholder = $(el.currentTarget);
        let input = this.form.find('[id="' + placeholder.attr("name") + '"]');
        let value = placeholder.text();

        if (input) {
            input.val(value).trigger("keyup");
            this.accessSubmitButton();
        }

        placeholder.css("min-width", value.length === 0 ? "60px" : "auto");
    }

    onOrientationChange(el) {
        const value = $(el.currentTarget).data();

        this.updateQueryString("orientation", value.orientation);
    }

    getHash() {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        return params.get('hash');
    }

    updateHash(hash) {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        params.set('hash', hash);

        // Update the URL without reloading the page
        const newUrl = `${url.pathname}?${params.toString()}`;
        window.history.replaceState(null, '', newUrl);
    }

    updateQueryString(key, value) {
        let url = new URL(window.location.href);
        url.searchParams.set(key, value);

        console.log(url.toString())
        window.location.href = url.toString();
    }

    setPlaceholderTitles() {
        this.template.find(".placeholder").each((_, el) => {
            const placeholder = $(el);
            const input = this.form.find('[id="' + placeholder.attr("name") + '"]');

            if (input && input.val()) {
                if (input.val().length === 0 && placeholder.val().length === 0) {
                    placeholder.text(input.attr("placeholder"));
                }
            }
        });
    }

    focusAndSelectAll(element) {
        const range = document.createRange();
        range.selectNodeContents(element); // Select all the content

        const selection = window.getSelection();
        selection.removeAllRanges(); // Clear any existing selections
        selection.addRange(range);
    }

    accessSubmitButton() {
        setTimeout(() => {
            if (!this.isFormFilled()) {
                this.submitButton.prop("disabled", true);
            } else {
                this.submitButton.prop("disabled", false);
            }
        }, 100);
    }

    observeContentChange() {
        const contentWatchers = document.querySelectorAll('.contentWatcher');

        if (!contentWatchers || contentWatchers.length === 0) {
            console.warn('No elements found with class .contentWatcher');
            return;
        }

        contentWatchers.forEach((watcher) => {
            if (watcher instanceof Node) { // Check if watcher is a valid Node
                let timeoutId;

                const observer = new MutationObserver(() => {

                    watcher.classList.remove('changed');

                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }

                    //if (!watcher.classList.contains('changed')) {
                    watcher.classList.add('changed'); // Add animation class when content changes

                    // Remove the animation class after animation ends
                    // watcher.addEventListener('animationend', () => {
                    //     watcher.classList.remove('animate');
                    // }, { once: true });

                    timeoutId = setTimeout(() => {
                        watcher.classList.remove('changed');
                    }, 1000); // Adjust the timeout duration as needed
                    //}
                });

                // Observe changes in child elements of .contentWatcher
                observer.observe(watcher, {childList: true, subtree: true});
            } else {
                console.error('Target element is not a valid Node:', watcher);
            }
        });
    }

    resetPlaceholders() {
        let placeholders = $(".placeholder, .value");

        placeholders.parent().removeClass("highlight");
        placeholders.find(".material-icons").remove();
    }

    setToContract(inputs) {
        inputs.each(function (_, e) {
            if ($(e).is(".update")) {

                let update = $(e).attr("name");
                let value = $(e).val();
                let placeholder = PriceOffer.el.find('[name="' + update + '"]:not(input):not(textarea)');

                if (placeholder && value.length !== 0) {
                    PriceOffer.setValue(placeholder, value);
                }
            }
        });
    }

    updateInputValuesToPlaceholders() {
        $(document).ready(() => {
            setTimeout(() => {
                if (this.valuesInserted === true) {
                    //return;
                }

                this.personTypeSelect.trigger("change");

                this.setToContract(this.formInputs);

                setTimeout(() => {
                    this.el.find("select.contract-select").trigger("change");
                }, 250);

                this.valuesInserted = true;
                console.info("Form data inserted into contract.");


                $(".offerLoading").fadeOut(400);

                setTimeout(() => {
                    this.template.removeClass("notLoaded");
                }, 600);
            }, 500);
        });
    }

    setValue(element, value) {
        if (this.isFloat(value)) {
            value = parseFloat(value).toLocaleString("sk-SK", {minimumFractionDigits: 2});
        }

        value = this.nl2br(value);
        value = this.transformValueByInput(element, value);

        return element.html('<span class="value">' + value + "</span>");
    }

    transformValueByInput(input, value) {

        if ($(input).is('[name="car-equipment"]')) {
            value = value.replaceAll("\n", "");

            let lines = value.split("<br>");

            value = "<p>" + lines.join("</p><p>") + "</p>";
        }

        return value;
    }

    isFloat(value) {
        const floatRegex = /^-?\d+\.\d+$/;

        return floatRegex.test(value);
    }

    isFormFilled() {
        const requiredInputs = this.form.find(".input.required").length;
        const filledInputs = this.form.find(".input.required.filled").length;

        return requiredInputs === filledInputs;
    }

    saveFormDataToUrl() {
        $(this.form).find('[name="g-recaptcha-response"]').remove();

        const formData = $(this.form).serialize();

        let fullUrl = window.location.href.split('?')[0];
        let finalUrl = fullUrl + "?" + formData;

        window.history.pushState(null, "", finalUrl);
    }

    highlightEmptyInputs() {
        setTimeout(() => {
            this.formInputs.each((_, el) => {
                if (!$(el).is(".required")) {
                    return;
                }

                let value = $(el).val();

                if (value.length === 0) {
                    $(el).addClass("invalid");
                } else {
                    $(el).removeClass("invalid");
                }
            });
        }, 2000);
    }

    debugFill(form) {

        this.el.addClass("debug");

        form.find(".input.required input:not([readonly])").each((_, el) => {
            let input = $(el);

            if (input.val().length === 0 && input.not('[name="contract-provision-value"]')) {
                const string = "M7_s.r.o. Limbová_1417/5 900_46 Most_pri_bratislave";
                const words = string.split(" ");
                const randomWord = words[Math.floor(Math.random() * words.length)];

                input.val(randomWord.replaceAll("_", " "));
            }

            if (input.is('[name="contract-provision-percent"]')) {
                input.val("5");
            }

            input.trigger("change");
            input.trigger("keyup");
        });

        setTimeout(() => {
            this.el.removeClass("debug");
        }, 5000);

        this.accessSubmitButton();

        console.info("DEBUG: Form filled");
    }

    generateRandomString(length) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    /**
     * This function is same as PHP's nl2br() with default parameters.
     *
     * @param {string} str Input text
     * @param {boolean} replaceMode Use replace instead of insert
     * @param {boolean} isXhtml Use XHTML
     * @return {string} Filtered text
     */
    nl2br(str, replaceMode, isXhtml) {
        let breakTag = (isXhtml) ? '<br />' : '<br>';
        let replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';

        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
    }
}

export default PriceOffer;